var map = {
	"./apple-developer.png": 20710,
	"./bank_slip.png": 65081,
	"./bank_slip_selected.png": 51418,
	"./check.png": 6313,
	"./credit_card.png": 82083,
	"./credit_card_flags.png": 51047,
	"./credit_card_selected.png": 83028,
	"./pix.png": 78772,
	"./pix_selected.png": 64931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95377;